import { Navigate, useLocation } from "react-router";
import type { CustomerAppConfigAuthError } from "undercarriage";

import { getAuthErrorPath } from "./app-config-auth-error-path";

export const AppConfigAuthRedirect = ({
  authError,
  children,
}: {
  authError: CustomerAppConfigAuthError | undefined;
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const authErrorPath = authError ? getAuthErrorPath(authError) : null;
  if (authErrorPath && authErrorPath !== location.pathname + location.search) {
    return <Navigate replace to={authErrorPath} />;
  }
  return children;
};
